import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useCartData } from 'b2b-apps/core/cart/hooks';
import { placeKanbanOrder } from 'b2b-apps/core/kanban';

export type UsePlaceKanbanOrderActionReturnType = () => void;

export const usePlaceKanbanOrderAction = (): UsePlaceKanbanOrderActionReturnType => {
  const dispatch = useDispatch();
  const cartData = useCartData();

  return useCallback(() => {
    dispatch(placeKanbanOrder({ references: cartData?.data?.summary?.lockerId }));
  }, [cartData, dispatch]);
};
